import React, { useEffect } from 'react';
import BrandingHeader from './components/BrandingHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';

const LoginScreen = () => {
  useEffect(() => {
    document.title = 'Login - TheVault';
  }, []);

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-background via-background to-muted/20 flex items-center justify-center p-4 md:p-6 lg:p-8">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex flex-col items-center justify-center space-y-8 md:space-y-10 lg:space-y-12">
          <BrandingHeader />
          
          <LoginForm />
          
          <SecurityBadges />
          
          <div className="text-center space-y-2 md:space-y-3">
            <p className="text-xs md:text-sm text-muted-foreground caption">
              Trusted by professional traders worldwide
            </p>
            <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground caption">
              <span>© {new Date()?.getFullYear()} TheVault</span>
              <span>•</span>
              <span>All rights reserved</span>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        .animate-shimmer {
          animation: shimmer 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default LoginScreen;